import utils from "../helpers/utils";

function init(): void {
  const selectBtn = document.querySelectorAll(".js-faux-dropdown");
  const selectMenu = document.querySelectorAll(".js-faux-dropdown-menu");
  const selectLink = document.querySelectorAll(".js-faux-item-link");

  for (let i = 0; i < selectBtn.length; i++) {
    const selBtn: HTMLElement = selectBtn[i] as HTMLElement;
    selBtn.setAttribute("aria-expanded", "false"); // Accessibility
    selBtn.onclick = function () {
      if (selBtn.className.indexOf("active") > -1) {
        utils.removeClass(selBtn, "active");
        selBtn.setAttribute("aria-expanded", "false"); // Accessibility
      } else {
        utils.addClass(this as HTMLElement, "active");
        selBtn.setAttribute("aria-expanded", "true"); // Accessibility

        const selectedItem = selBtn?.nextElementSibling?.querySelector(".selected");
        if (selectedItem) {
          (selectedItem as HTMLElement).focus();
        } else {
          const firstItem = selBtn?.nextElementSibling?.querySelector(".js-faux-item-link");
          if (firstItem) {
            (firstItem as HTMLElement).focus();
          }
        }
      }
    };
    window.addEventListener("click", function (e) {
      if (e.target !== selBtn) {
        utils.removeClass(selBtn, "active");
        selBtn.setAttribute("aria-expanded", "false"); // Accessibility
      }
    });
    // Accessibility
    selBtn.setAttribute("aria-haspopup", "listbox");
  }

  // Clicking inside the dropdown doesn't close the dropdown if disableAutoClose
  for (let i = 0; i < selectMenu.length; i++) {
    const selMenu: HTMLElement = selectMenu[i] as HTMLElement;
    selMenu.onclick = function (e) {
      if (selMenu.dataset.disableAutoClose) {
        e.stopPropagation();
      }
    };
  }

  // Accessibility:
  for (let g = 0; g < selectMenu.length; g++) {
    const selMenu: HTMLElement = selectMenu[g] as HTMLElement;
    selMenu.setAttribute("role", "menu");
    selMenu.setAttribute("tabindex", "-1");
  }
  for (let h = 0; h < selectLink.length; h++) {
    const selItem: HTMLElement = selectLink[h] as HTMLElement;
    selItem.setAttribute("role", "option");
    if (selItem.classList.contains("selected")) {
      selItem.setAttribute("aria-selected", "true");
    }
  }
}

export default { init };

// Bare template to create an accessible dropdown - update this if it changes
// <div class="faux-dropdown">
//     @* js-faux-dropdown is the class that adds interactivity *@
//     @* Add an aria-label that is made out of ideally the label + the selected option, if such exists - try avoiding words that don't come from the CMS like "please select" - as it would need to be translatable *@
//     <button class="faux-dropdown__trigger js-faux-dropdown"
//             @* selectlabel should come from the CMS as needs to be translatable *@
//             aria-label="@Model.CurrentBlock.SelectLabel @(selectedItem == null ? string.Empty : loginHelper.GetRoleName(selectedItem))">
//         @(selectedItem == null ? Model.CurrentBlock.SelectLabel : loginHelper.GetRoleName(selectedItem))
//     </button>
//     @* js-faux-dropdown-menu is also required for interactivity *@
//     <ul class="faux-dropdown__menu js-faux-dropdown-menu"
//         aria-label="@Model.CurrentBlock.SelectLabel"
//         @* optional: add an aria attribute pointing to the id of active item *@
//         @if (selectedItemId != null) { <text> @string.Format(" aria-activedescendant=select-list-{0}", selectedItemId) </text> }>
//         @foreach (const item in Model.Items)
//         {
//             const selected = selectedItem != null && item == selectedItem;
//             <li>
//                 @* add faux-dropdown__menu-item-link--with-ticks so that the item will have a tick icon *@
//                 @* add selected class to the item currently selected (optional - accessibility) *@
//                 @* js-faux-item-link used for accessibility - add a relevant aria attr & focuses it when the menu opens *@
//                 <a class="faux-dropdown__menu-item-link@(selected ? " selected faux-dropdown__menu-item-link--with-ticks" : string.Empty) js-faux-item-link"
//                 href="" @* optional depending on what needs to be achieved *@
//                 id="role-select-list-hat-@item.Id"> @* optional: use if using aria-activedescendant *@
//                     <span class="faux-dropdown__menu-item-link-text">@item.Name</span>
//                 </a>
//             </li>
//         }
//     </ul>
// </div>
